import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarEdit = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.5 2V4H15.5V2H17V4H21V11H19.5V10H4.5V19.5H12V21H3V4H7V2H8.5ZM4.5 8.5H19.5V5.5H4.5V8.5ZM20.25 12.6893L23.3107 15.75L17.0607 22H14V18.9393L20.25 12.6893ZM15.5 19.5607V20.5H16.4393L21.1893 15.75L20.25 14.8107L15.5 19.5607Z",
		fill: "currentColor"
	})]
});
export default SvgCalendarEdit;
